/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketplace_HandleInputs */

const en_marketplace_handle = /** @type {(inputs: Marketplace_HandleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marketplace Handle`)
};

const es_marketplace_handle = /** @type {(inputs: Marketplace_HandleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usuario del mercado`)
};

const fr_marketplace_handle = /** @type {(inputs: Marketplace_HandleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Identifiant Marketplace`)
};

const de_marketplace_handle = /** @type {(inputs: Marketplace_HandleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marktplatz-Handle`)
};

const ja_marketplace_handle = /** @type {(inputs: Marketplace_HandleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`マーケットプレイスのハンドル名`)
};

const zh_marketplace_handle = /** @type {(inputs: Marketplace_HandleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`市场专属代号 (Handle)`)
};

const ar_marketplace_handle = /** @type {(inputs: Marketplace_HandleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اسم المستخدم في السوق`)
};

const id_marketplace_handle = /** @type {(inputs: Marketplace_HandleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Handle Marketplace`)
};

const it_marketplace_handle = /** @type {(inputs: Marketplace_HandleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome Utente Marketplace`)
};

const ru_marketplace_handle = /** @type {(inputs: Marketplace_HandleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Имя в маркетплейсе (Handle)`)
};

const pt_marketplace_handle = /** @type {(inputs: Marketplace_HandleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome de Usuário (Handle)`)
};

const ko_marketplace_handle = /** @type {(inputs: Marketplace_HandleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`마켓플레이스 핸들(ID)`)
};

/**
* | output |
* | --- |
* | "Marketplace Handle" |
*
* @param {Marketplace_HandleInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const marketplace_handle = /** @type {((inputs?: Marketplace_HandleInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketplace_HandleInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketplace_handle(inputs)
	if (locale === "es") return es_marketplace_handle(inputs)
	if (locale === "fr") return fr_marketplace_handle(inputs)
	if (locale === "de") return de_marketplace_handle(inputs)
	if (locale === "ja") return ja_marketplace_handle(inputs)
	if (locale === "zh") return zh_marketplace_handle(inputs)
	if (locale === "ar") return ar_marketplace_handle(inputs)
	if (locale === "id") return id_marketplace_handle(inputs)
	if (locale === "it") return it_marketplace_handle(inputs)
	if (locale === "ru") return ru_marketplace_handle(inputs)
	if (locale === "pt") return pt_marketplace_handle(inputs)
	return ko_marketplace_handle(inputs)
});